import type { StayHistoryRow } from "@/hooks/usePatientHistoryFeed";
import type { PanelPet } from "@/pages/daycare-hotel/panel/panelModel";

type HistoryStayDialogRow = StayHistoryRow & { petName: string; ownerName?: string | null };

const normalizeTime = (value: string | null) => value?.slice(0, 5) ?? null;

export function toHistoryStayPanelPet(row: HistoryStayDialogRow): PanelPet {
  const nature = row.moduleType === "hotel" ? "hotel" : row.moduleType === "both" ? "both" : "daycare";
  const status = row.status === "checked_in" || row.status === "checked_out" || row.status === "cancelled" || row.status === "no_show"
    ? row.status
    : "reserved";

  return {
    reservationId: row.reservationId,
    stayDayId: row.id,
    petId: row.petId,
    petName: row.petName,
    ownerName: row.ownerName ?? "",
    ownerId: null,
    isBirthday: false,
    nature,
    status,
    size: "unknown",
    period: null,
    checkInTime: normalizeTime(row.checkInTime),
    checkOutTime: normalizeTime(row.checkOutTime),
    ownerPhone: null,
    isOvernight: nature === "daycare" && Boolean(row.isOvernight),
    inAdaptation: false,
    bedLabel: row.bedLabel,
    stayRange: null,
    lastStayDate: row.stayDate,
    alerts: [],
    incompatibleWith: [],
  };
}
